// extracted by mini-css-extract-plugin
export var arrow = "_3g-6";
export var changeItem = "_3g-3";
export var changesHeader = "_3g-1";
export var changesList = "_3g-2";
export var container = "_3g-0";
export var pathLabel = "_3g-4";
export var value = "_3g-7";
export var valuesContainer = "_3g-5";